// @flow

import { h }             from "preact";
import { connect }       from "preact-redux";
import { PureComponent } from "shared-components";
import styles            from "./styles.scss";
import classNames        from "classnames";

import QtyPicker         from "components/QtyPicker";

import { PUTTING } from "reducers/cart";

@connect(state => ({
  cartItems: state.cart.items,
  loading:   state.cart.state === PUTTING,
}))
export default class SimpleQtyPicker extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      qty: 1,
    };
  }

  putCart = ({ value }) => {
    const items = this.props.cartItems.map(x => ({
      productId: x.product.id,
      qty: x.qty
    }));

    const item = items.find(x => x.productId === this.props.product.id);

    if (item) {
      item.qty = value;
    } else {
      items.push({
        productId: this.props.product.id,
        qty: value
      })
    }

    this.props.putCart(items.filter(x => x.qty > 0));
  }

  render({ basePrice, msrp, cartItems, product, loading }, { qty }, { t }: Context) {
    const optionsArray = [0, 1, 2, 3, 5, 10];
    const item = cartItems.find(x => x.product.id === product.id);
    const itemQty  = item ? item.qty : 0;

    return (
      <div class={styles.block}>
        <h2
          class={styles.title}>
          {product.attributes.qty_title ? t("PRODUCT.QTY_TITLE", { title: product.attributes.qty_title }) : t("PRODUCT.QTY_TITLE_FALLBACK")}
        </h2>

        <QtyPicker
          min={0}
          max={10}
          qty={itemQty}
          disabled={loading}
          setQty={x => this.putCart({ value: x })}
        />
      </div>
    );
  }
}
